import { render, staticRenderFns } from "./PageMyJourneySkeleton.vue?vue&type=template&id=27241a97&scoped=true"
import script from "./PageMyJourneySkeleton.vue?vue&type=script&lang=js"
export * from "./PageMyJourneySkeleton.vue?vue&type=script&lang=js"
import style0 from "./PageMyJourneySkeleton.vue?vue&type=style&index=0&id=27241a97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27241a97",
  null
  
)

export default component.exports